import { Toaster as SonnerToaster } from 'sonner';
import { useUiStore } from '@noor/lib';

/**
 * App-wide toast host. Themed to the design tokens (the sonner toasts inherit
 * the app's light/dark theme via the store). Mounted once in app providers.
 */
export function Toaster() {
  const theme = useUiStore((s) => s.theme);
  return (
    <SonnerToaster
      theme={theme}
      position="top-right"
      richColors
      closeButton
      expand
      visibleToasts={5}
      gap={8}
      toastOptions={{
        classNames: {
          toast: 'rounded-xl border shadow-lg',
        },
      }}
    />
  );
}
